var hugggMap = {
  account_id: 'accountId',
  assigned_client: 'assignedClient',
  assigned_date: 'assignedDate',
  code: 'code',
  created_at: 'createdAt',
  deleted_at: 'deletedAt',
  expiry_date: 'expiryDate',
  hug_status: 'hugStatus',
  id: 'id',
  image_url: 'imageUrl',
  is_expired: 'isExpired',
  launch_url: 'launchUrl',
  message_id: 'messageId',
  notes: 'notes',
  order_id: 'orderId',
  purchase_id: 'purchaseId',
  receiver_id: 'receiverId',
  redeem_code: 'redeemCode',
  redeemed_id: 'redeemedId',
  reminder_sent: 'reminderSent',
  sender_id: 'senderId',
  sent_date: 'sentDate',
  shortcode: 'shortcode',
  status: 'status',
  status_code: 'statusCode',
  status_id: 'statusId',
  transaction_id: 'transactionId',
  type: 'type',
  theme_id: 'themeId',
  theme_info: 'themeInfo',
  updated_at: 'updateAt',
  vid: 'vid',
  viewed_client: 'viewedClient',
  viewed_date: 'viewedDate',
  voucher_id: 'voucherId'
};
export default hugggMap;